<template>
  <b-card no-body>
    <template v-slot:header>
      <h2 class="mb-0">
        <template v-if="innerSection.id">Редактирование направления/раздела #{{ innerSection.id }}</template>
        <template v-else>Добавление направления/раздела</template>
      </h2>
    </template>

    <div class="block" v-if="Object.keys($page.props.errors).length > 0">
      <b-alert class="mb-0" variant="danger" :show="Object.keys($page.props.errors).length > 0">
        <h4 class="alert-heading">Исправьте ошибки и попробуйте сохранить снова</h4>
        <ul class="list-unstyled mb-0">
          <template v-for="(errors, name) in $page.props.errors">
            <li v-for="(error, i) in errors" :key="name+i">
              {{ error }}
            </li>
          </template>
        </ul>
      </b-alert>
    </div>

    <b-form @submit.prevent="onSubmit">
      <div class="block bg-galsen">
        <b-form-row>
          <div class="col-4">
            <b-form-group label="Направление" :invalid-feedback="fieldError('parent_id')">
              <b-form-select v-model="innerSection.parent_id" :options="sectionsOptions" :state="fieldState('parent_id')"></b-form-select>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group label="Внутренний №" :invalid-feedback="fieldError('inner_id')">
              <b-input v-model="innerSection.inner_id"
                       :state="fieldState('inner_id')"></b-input>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group label="Сортировка" :invalid-feedback="fieldError('order')">
              <b-input v-model="innerSection.order"
                       type="number"
                       :state="fieldState('order')"></b-input>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group label="Прочее" :invalid-feedback="fieldError('is_active')">
              <b-form-checkbox v-model="innerSection.is_active" :state="fieldState('is_active')" switch>
                Опубликован
              </b-form-checkbox>
            </b-form-group>
          </div>
        </b-form-row>
      </div>

      <div class="block">
        <b-form-row>
          <div class="col">
            <b-form-group label="Название" :invalid-feedback="fieldError('title')">
              <b-input required v-model="innerSection.title"
                       :state="fieldState('title')"></b-input>
            </b-form-group>
          </div>
          <div class="col">
            <b-form-group label="URL" :invalid-feedback="fieldError('slug')">
              <b-input v-model="innerSection.slug"
                       :state="fieldState('slug')"></b-input>
            </b-form-group>
          </div>
        </b-form-row>
      </div>

      <div class="block">
        <file-manager v-model="showFileManager" type="image" @select="pasteFilePath($event)"></file-manager>

        <b-form-group label="Пример использования" :invalid-feedback="fieldError('description_example')" :state="fieldState('description_example')">
          <b-btn size="sm" variant="outline-secondary" @click="showFileManager = true; fileManagerTarget = 'exampleEditor'">Вставить файл</b-btn>
          <br><br>
          <editor v-model="innerSection.description_example" lang="html" @init="initEditor" width="100%" height="300" ref="exampleEditor"></editor>
        </b-form-group>

        <b-form-group label="Квалификация" :invalid-feedback="fieldError('description_qualification')" :state="fieldState('description_qualification')">
          <b-btn size="sm" variant="outline-secondary" @click="showFileManager = true; fileManagerTarget = 'qualificationEditor'">Вставить файл</b-btn>
          <br><br>
          <editor v-model="innerSection.description_qualification" lang="html" @init="initEditor" width="100%" height="300" ref="qualificationEditor"></editor>
        </b-form-group>

        <div class="text-right mt-3">
          <b-btn :disabled="! innerSection.can.delete" @click="onDelete()" v-if="innerSection.id"
                 variant="outline-light" class="text-danger mr-3">Удалить</b-btn>
          <b-btn-group>
            <b-btn :disabled="innerSection.id ? ! innerSection.can.update : ! $page.props.can.sections['create']"
                   @click="onSubmit($event)"
                   size="lg" variant="outline-primary">Применить</b-btn>
            <b-btn :disabled="innerSection.id ? ! innerSection.can.update : ! $page.props.can.sections['create']"
                   @click="onSubmit($event, true)"
                   size="lg" variant="outline-primary">Сохранить и закрыть</b-btn>
          </b-btn-group>
        </div>
      </div>

    </b-form>
  </b-card>
</template>

<script>
import FileManager from '~/Components/FileManager/FileManager'

export default {
  components: {
    editor: require('vue2-ace-editor'),
    FileManager
  },
  props: {
    section: Object,
    sections: Array
  },
  remember: 'innerSection',
  data () {
    return {
      showFileManager: false,
      fileManagerTarget: null,
      innerSection: {
        id: null,
        parent_id: null,
        is_active: true,
        inner_id: null,
        order: null,
        title: '',
        slug: '',
        description_example: '',
        description_qualification: '',
        icon: null
      },
      imgSrc: null
    }
  },

  created () {
    if (this.section) {
      this.innerSection = { ...this.section }
    }
  },

  methods: {
    initEditor () {
      require('brace/mode/html')
      require('brace/mode/javascript')
      require('brace/theme/chrome')
    },

    onSubmit (event, redirectToList = false) {
      if (Number.isInteger(this.innerSection.id)) {
        const route = this.route('backend.sections.update', {
          section: this.innerSection.id,
          ...(redirectToList && { redirectToList: true })
        })

        this.$inertia.post(route, { ...this.innerSection, _method: 'PUT' })
        return
      }

      const route = this.route('backend.sections.store', { ...(redirectToList && { redirectToList: true }) })
      this.$inertia.post(route, this.innerSection)
    },

    onDelete () {
      if (!confirm('Вы уверены?')) {
        return
      }

      this.$inertia.delete(this.route('backend.sections.destroy', this.innerSection.id))
    },

    pasteFilePath (event) {
      this.$refs[this.fileManagerTarget].editor.insert(event)
    }
  },
  computed: {
    sectionsOptions () {
      const options = this.sections.map(rootSection => ({
        value: rootSection.id,
        html: rootSection.inner_id + ' ' + rootSection.title
      }))

      options.unshift({ value: null, html: '---- Сделать направлением ----' })

      return options
    }
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
.block {
  padding: 20px;
}
</style>
